import React, { useState } from 'react';
import MasterPage from './MasterPage';
import readUrl from './commons'

// Assuming the 'loc' value can be passed as a prop or computed dynamically in a higher-level component.
const FoodBeverageIndustry = ({ loc = '' }) => {
    //const title = `Best ERP Software for Food & Beverage Industry ${loc} | Best Food & Beverage Industry ERP Software ${loc} | Business Management Solutions - Tejaxo Software`;
    //const metaDesc = `Tejaxo Software is a High Rated Pharmaceutical ERP Software ${loc} and BI software for Building Material Suppliers${loc}, providing Barcode based automatic Production Enterprise Resource Planning (ERP) software ${loc}, business management solutions, services and support.`;
    //const metaKey = `Tejaxo Food & Beverage Industry ERP ${loc}, ERP Software for Food & Beverage Industry`;

    var aaa = readUrl();
    const [state, setState] = useState(aaa);
    return (
        <MasterPage state={state} >
        <>
            {/*<head>*/}
            {/*    <title>{title}</title>*/}
            {/*    <meta name="description" content={metaDesc} />*/}
            {/*    <meta name="keywords" content={metaKey} />*/}
            {/*</head>*/}
            <section id="about" className="wow fadeInUp" style={{ backgroundColor: 'white' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 about-img">
                            <img src="~/theme/img/food-bev-1-1024x683.jpg" alt="Food & Beverage Industry" />
                        </div>
                            <div className="col-lg-6 content">
                                <h1 className="elementor-heading-title elementor-size-default">Food &amp; Beverage Industry {state.condText}</h1>
                        </div>
                    </div>
                    <br />
                    <div className="row">
                        <div className="col-lg-6 about-img">
                            <h2 className="elementor-heading-title elementor-size-default">The challenge is in the name; Fast Moving Consumer Goods (FMCG).</h2>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    The industry is under constant pressure to keep up with customers who have an endless appetite for innovative food and beverage choices. This demands an agile approach to operations with the ability to make changes quickly. Access to insights that accurately forecast demand and calculate production costs is critical. At the same time, there is a growing desire amongst consumers to understand the source of the products they buy. This requires a visibility over your entire supply chain, beyond the walls of production facilities.
                                </span>
                            </p>
                        </div>
                        <div className="col-lg-6 content">
                            <img src="~/theme/img/food-bev-2-768x512.jpg" alt="Food & Beverage Insight" />
                        </div>
                    </div>
                    <br />
                    <div className="row">
                        <div className="col-lg-6 about-img">
                            <img src="~/theme/img/bdim6.JPG" alt="Data Management" />
                        </div>
                        <div className="col-lg-6 content">
                            <h2 className="elementor-heading-title elementor-size-default">Tejaxo Software can provide your business with a complete ecosystem that ensures the information you need to make decisions and operate efficiently is at your fingertips.</h2>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    We can help facilitate growth by giving you tools to understand what is driving consumer purchase decisions, so you can gear your production processes accordingly, reduce costs and maintain precise data records and standards. It�s all the information you need to stay flavour of the month.
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            </>
        </MasterPage>
    );
};

export default FoodBeverageIndustry;
